import { HttpClient } from '../HttpClient';
/**
 * * Get Feature Flag List
 */

export const GetFeatureFlagList = async () => {
  try {
    const { data } = await HttpClient.get('api/featureflags');

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
